<template>
  <Modal v-model="adjustingSubsidiesModal" :title="$t('key1001978')" width="550" class-name="adjustingSubsidiesStyle"
    :transfer="false" :mask-closable="false" @on-visible-change="adjustingSubsidiesChange">
    <Form ref="adjustingSubsidiesForm" :model="adjustingSubsidiesForm" :rules="ruleValidate" :label-width="110">
      <Row style="width: 90%;" @submit.native.prevent>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003904')">
            <span>{{ subsidyAmount + ' ' + currencyState }}</span>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003905')" prop="modifySubsidyMoney">
            <div class="flex align-items-center">
              <InputNumber :placeholder="$t('key1003906')" :max="999999999" :min="0" style="width:90%"
                v-model="adjustingSubsidiesForm.modifySubsidyMoney" :formatter="(value) => formatterNumber(value, 2)"></InputNumber>
              <span class="ml10">{{ currencyState }}</span>
            </div>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003907')" prop="modifyDirections">
            <Input
              type="textarea"
              :placeholder="$t('key1003908')"
              :autosize="{ minRows: 3, maxRows: 5}"
              v-model.trim="adjustingSubsidiesForm.modifyDirections">
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="adjustingSubsidiesModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="adjustingSubsidiesBtn">{{ $t('key1000543') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {formatterNumber} from "@/utils/common";

export default {
  name: "adjustingSubsidiesModal",
  mixins: [Mixin],
  data() {
    return {
      adjustingSubsidiesForm: {
        modifySubsidyMoney: null,
        modifyDirections: ''
      },
      ruleValidate: {
        modifySubsidyMoney: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003902'), trigger: 'change'}
        ],
        modifyDirections: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003903'), trigger: 'blur'}
        ],
      },
      adjustingSubsidiesModal: false,
      ymsPickupOrderId: null,
      subsidyAmount: 0
    };
  },
  methods: {
    formatterNumber,
    // 初始化数据
    initAdjustingSubsidiesData(ymsPickupOrderId, subsidyAmount) {
      this.ymsPickupOrderId = ymsPickupOrderId;
      this.subsidyAmount = subsidyAmount;
      this.adjustingSubsidiesModal = true;
    },
    // 确认按钮
    adjustingSubsidiesBtn() {
      let v = this;
      let query = {
        modifyDirections: v.adjustingSubsidiesForm.modifyDirections,
        modifySubsidyMoney: v.adjustingSubsidiesForm.modifySubsidyMoney,
        ymsPickupOrderId: v.ymsPickupOrderId
      };
      v.$refs['adjustingSubsidiesForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_ymsPickupOrder_updateSubsidyAudit, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247'),}).then(response => {
            if (response.data.code === 0) {
              v.adjustingSubsidiesModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    adjustingSubsidiesChange(value) {
      if (!value) {
        this.$refs['adjustingSubsidiesForm'].resetFields();
        this.ymsPickupOrderId = null;
        this.subsidyAmount = 0;
      }
    }
  }
};
</script>

<style scoped>

</style>